import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { combineLatest, map, Subscription } from 'rxjs';
import { ProductComparatorFloatingService } from './core/product-comparator-floating.service';
import { PRODUCT_COMPARATOR_TYPE } from '../product-comparator/core/product-comparator.model';
import { Product } from '@spartacus/core';
import { LocalStorageService } from '../../../../core/services/localStorage.service';
import { PageLayoutService } from '@spartacus/storefront';
import { DEVICE_SIZE } from '../../../../core/models/others.model';

@Component({
  selector: 'product-comparator-floating',
  templateUrl: './product-comparator-floating.component.html',
  styleUrl: './product-comparator-floating.component.scss',
  standalone: false,
})
export class ProductComparatorFloatingComponent implements OnInit, OnDestroy {
  @ViewChild('container') container?: ElementRef;

  DEVICE_SIZE = DEVICE_SIZE;
  STORE = PRODUCT_COMPARATOR_TYPE.FLOATTING;
  subscription = new Subscription();
  products$ = this.floattingService.store$.asObservable().pipe(map(store => store.products));
  expanded$ = this.floattingService.expanded$;

  constructor(
    private floattingService: ProductComparatorFloatingService,
    private localStorageService: LocalStorageService,
    private pageLayoutService: PageLayoutService,
  ) {}

  get $container(): HTMLDivElement {
    return this.container?.nativeElement as HTMLDivElement;
  }

  ngOnInit(): void {
    this.recoverStore();
    this.checkStore();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  recoverStore(): void {
    const store =
      this.localStorageService.getItem('productFloattingComparator') ||
      JSON.stringify(this.floattingService.storeInitialState);

    this.floattingService.store$.next(JSON.parse(store));
  }

  checkStore(): void {
    this.subscription.add(
      combineLatest([this.floattingService.store$, this.pageLayoutService.page$]).subscribe(([store, page]) => {
        this.localStorageService.setItem('productFloattingComparator', JSON.stringify(store));

        setTimeout(() => {
          if (store.products.length > 0 && page.pageId !== 'prdCompare-page') {
            this.$container?.classList?.add('active');
          } else {
            this.$container?.classList?.remove('active');
          }

          const floatingState = this.localStorageService.getItem('productFloattingComparatorState') || '';
          floatingState === 'expanded' ? this.openContainer() : this.closeContainer();
          floatingState && this.$container.classList.add(floatingState);
        }, 20);
      }),
    );
  }

  toggleComparator() {
    const isExpanded = this.expanded$.value;
    isExpanded ? this.closeContainer() : this.openContainer();
  }

  closeContainer() {
    this.floattingService.closeContainer();
  }

  openContainer() {
    this.floattingService.openContainer();
  }

  createPlaceHolder(qty: number): any[] {
    return Array(this.floattingService.maxProducts - qty).fill(null);
  }

  getProductID(products: Product[]): string {
    return products.map(product => product.code).join(',');
  }

  removeAllProducts() {
    this.floattingService.removeAllProducts();
  }
}
